import { axiosInstance } from "../../../axios/axiosInstance";
import { LANDING_API_URL, getDefaultHeaders } from "../../../config";

const authHeaders = (extra = {}) => {
  const authToken = localStorage.getItem("authToken");
  return {
    ...getDefaultHeaders(),
    Authorization: `Bearer ${authToken}`,
    ...extra,
  };
};

export const getBlogs = () =>
  axiosInstance.get(`${LANDING_API_URL}/blogs`, {
    headers: authHeaders(),
  });

export const createBlogRequest = (formData) =>
  axiosInstance.post(`${LANDING_API_URL}/blogs`, formData, {
    headers: authHeaders({ "Content-Type": "multipart/form-data" }),
  });

export const updateBlogRequest = (blogId, formData) =>
  axiosInstance.post(`${LANDING_API_URL}/blogs/update/${blogId}`, formData, {
    headers: authHeaders({ "Content-Type": "multipart/form-data" }),
  });

export const removeBlog = (blogId) =>
  axiosInstance.delete(`${LANDING_API_URL}/blogs/${blogId}`, {
    headers: authHeaders(),
  });
